import { FlexRow, Panel, Text, Avatar, FlexSpacer } from '@epam/promo';
import { FlexCell } from '@epam/uui-components';
import { PermissionControl } from 'components/permissions/PermissionControl';
import { useUserStore } from 'store/user.store';
import { USER_ROLE } from 'models/user.model';
import { PermissionCardProps } from './PermissionCard.model';
import css from './PermissionCard.module.scss';

export const PermissionCard = ({ user }: PermissionCardProps) => {
  const currentUser = useUserStore((state) => state.user);
  const isCurrentUser = currentUser.email === user.email;
  const fullName = user.firstName ? `${user.firstName} ${user.lastName}` : '';

  return (
    <FlexRow cx={css['permission-card']}>
      <Avatar
        alt={user.email}
        cx={css['permission-card__avatar']}
        img={user.avatar}
        size="30"
      />
      <Panel cx={css['permission-card__name']}>
        <Text color="gray80" font="sans-semibold" size="24">
          {fullName} {isCurrentUser ? '(You)' : ''}
        </Text>
        <Text color="gray60" size="18">
          {user.email}
        </Text>
      </Panel>
      <FlexSpacer />
      <FlexCell cx={css['permission-card__picker']}>
        {user.email !== currentUser.email ? (
          <PermissionControl user={user} />
        ) : (
          <Text color="gray80" cx={css['permission-card__role']} size="30">
            {USER_ROLE[user.role]}
          </Text>
        )}
      </FlexCell>
    </FlexRow>
  );
};
